import React, { useContext, useEffect } from 'react'
import { Content } from '../../../../_myb/layout/components/content'
import { ToolbarWrapper } from '../../../../_myb/layout/components/toolbar/ToolbarWrapper'
import { defaultToolbarState, ToolbarContext } from '../../../../_myb/layout/components/toolbar/Toolbar'
import { PageTitle } from '../../../../_myb/layout/core'
import { KTIcon } from '../../../../_myb/helpers'
import { AccessibleTiles } from '../../widgets/components/AccessibleTiles'

const RestrictedPage: React.FC = () => {
  const { updateToolbar } = useContext(ToolbarContext)

  useEffect(() => {
    updateToolbar({
      ...defaultToolbarState,
      alwaysDisplay: true,
    })
  }, [])

  return (
    <>
      <PageTitle showBizPicker />
      <ToolbarWrapper />
      <Content>
        {/* Access denied banner */}
        <div className='d-flex align-items-center gap-5 p-7 mb-8 rounded-3 bg-light-danger border border-danger border-opacity-25'>
          <div className='w-55px h-55px flex-shrink-0 rounded-2 d-flex align-items-center justify-content-center bg-danger'>
            <KTIcon iconName='shield-cross' className='text-white fs-2' />
          </div>
          <div>
            <h4 className='fw-bold text-danger mb-1'>
              {'Access Not Available'.toTranslatedDisplay()}
            </h4>
            <p className='text-gray-600 mb-0 fs-6'>
              {"You don't have permission to access this page. Contact your administrator if you need access.".toTranslatedDisplay()}
            </p>
          </div>
        </div>

        {/* Accessible modules */}
        <div className='mb-6'>
          <h5 className='fw-bold text-gray-900 mb-1'>{'Your Accessible Modules'.toTranslatedDisplay()}</h5>
          <p className='text-muted fs-7'>
            {'Here are the areas you can access with your current role.'.toTranslatedDisplay()}
          </p>
        </div>

        <AccessibleTiles />
      </Content>
    </>
  )
}

export default RestrictedPage
